<div
  *ngIf="cartResetBanner"
  class="exclusives-tab__reset-banner"
  role="alert"
>
  <span>{{ cartResetBanner }}</span>
  <button
    type="button"
    class="exclusives-tab__reset-dismiss"
    aria-label="Dismiss"
    (click)="dismissCartResetBanner()"
  >
    <nb-icon icon="close-outline"></nb-icon>
  </button>
</div>

<ng-container *ngIf="cart$ | async as cart; else empty">
  <ng-container *ngIf="cart.lines.length > 0; else empty">
    <ul class="exclusives-tab__lines">
      <li
        *ngFor="let line of cart.lines"
        class="exclusives-tab__line"
        [class.is-pending]="isPending(line.id)"
      >
        <div class="exclusives-tab__line-image">
          <img
            *ngIf="line.image"
            [src]="line.image | withWidth: 240"
            [alt]="line.title"
          />
        </div>
        <div class="exclusives-tab__line-info">
          <p class="exclusives-tab__line-title">{{ line.title }}</p>
          <p class="exclusives-tab__line-price">{{ formatPrice(line.unitPrice) }}</p>

          <div class="exclusives-tab__line-controls">
            <div class="exclusives-tab__stepper" role="group" aria-label="Quantity">
              <button
                type="button"
                class="exclusives-tab__qty-btn"
                [disabled]="line.quantity <= 1 || isPending(line.id)"
                (click)="decrement(line.id, line.quantity)"
                aria-label="Decrease quantity"
              >
                −
              </button>
              <span class="exclusives-tab__qty">{{ line.quantity }}</span>
              <button
                type="button"
                class="exclusives-tab__qty-btn"
                [disabled]="isPending(line.id)"
                (click)="increment(line.id, line.quantity)"
                aria-label="Increase quantity"
              >
                +
              </button>
            </div>
            <app-delete-button
              label="Remove"
              class="exclusives-tab__remove"
              (delete)="remove(line.id)"
            ></app-delete-button>
          </div>

          <p
            *ngIf="warningFor(line.id) as warning"
            class="exclusives-tab__line-warning"
            role="status"
          >
            <nb-icon icon="alert-triangle-outline" aria-hidden="true"></nb-icon>
            <span>{{ warning }}</span>
          </p>
        </div>
      </li>
    </ul>

    <div *ngIf="pendingError" class="exclusives-tab__error" role="alert">
      {{ pendingError }}
    </div>

    <footer class="exclusives-tab__footer">
      <p
        *ngIf="freeShipping(cart) as shipping"
        class="exclusives-tab__shipping"
        [class.is-qualified]="shipping.qualified"
        role="status"
      >
        <nb-icon
          [icon]="shipping.qualified ? 'checkmark-circle-2-outline' : 'car-outline'"
          aria-hidden="true"
        ></nb-icon>
        <span *ngIf="shipping.qualified">Your order ships free</span>
        <span *ngIf="!shipping.qualified">
          Add <strong>{{ shipping.remaining }}</strong> for free shipping
        </span>
      </p>

      <div class="exclusives-tab__subtotal">
        <span>Subtotal</span>
        <strong>{{ formatPrice(cart.subtotal) }}</strong>
      </div>
      <button
        nbButton
        status="primary"
        size="large"
        fullWidth
        class="exclusives-tab__checkout"
        [disabled]="!cart.checkoutUrl"
        (click)="checkout(cart)"
      >
        Checkout — {{ formatPrice(cart.subtotal) }}
      </button>
    </footer>
  </ng-container>
</ng-container>

<ng-template #empty>
  <div class="exclusives-tab__empty">
    <nb-icon icon="shopping-cart-outline" class="exclusives-tab__empty-icon"></nb-icon>
    <p class="exclusives-tab__empty-text">Your Online Exclusives cart is empty</p>
    <a routerLink="/exclusives" class="exclusives-tab__empty-link">Browse exclusives →</a>
  </div>
</ng-template>
